module.exports = __webpack_public_path__ + "img/merck.8e939d74.svg";